import {
  SeleccionLaboratorioBody,
  SeleccionLaboratorioBotonAzul,
  SeleccionLaboratorioContainer,
  SeleccionLaboratorioGrid,
  SeleccionLaboratorioHeader,
} from "./localStyle";
import { useHistory, useLocation } from "react-router";
import { useContext, useEffect, useState } from "react";
import { showToaster } from "global/context/action/toaster/toaster";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import Layout from "_+_Portal/components/Genericos/Layout/Layout";
import BarraAzul from "_+_Portal/_-_Autocheckin/components/genericos/BarraAzul/BarraAzul";
import { setNuevoTurno } from "_+_Portal/context/Actions/nuevoTurno/nuevoTurno";
import {
  wsGetLaboTurnos,
  wsGetVerificarLaboGrupo,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import { PortalContext } from "_+_Portal/context/Provider";
import ModalVerificaOs from "_+_Portal/_-_Autocheckin/components/genericos/ModalVerificaOs/ModalVerificaOs";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import Modal from "global/component/Genericos/Modal/Modal";

const SeleccionLaboratorio = () => {
  //#region --------- context ---------------
  const { authState, toasterDispatch, modalState, modalDispatch } =
    useContext(GlobalContext);
  const {
    laboGrupoState,
    laboTurnosDispatch,
    nuevoTurnoDispatch,
    nuevoTurnoState,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
  } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [loading, setLoading] = useState(false);
  const [listaTurnos, setListaTurnos] = useState(laboGrupoState.laboGrupo.data);
  const dtoVerificaOs = {
    fechaDesde: null,
    particular: false,
    idPacFamiliar: -1,
    osAlternativa: false,
    flgVideoAtencion: nuevoTurnoState.nuevoTurno.videoAtencion,
    id: null,
    laboSeleccion: null,
  };
  const pacienteSeleccionado = nuevoTurnoState.nuevoTurno.familiar?.paciente;
  const history = useHistory();
  const idCircuitoMensajesList = [1, 3, 5, 6, 7, 8];
  const idCircuitoParticular = [9];
  const idCircuitoOsAlternativa = [91];
  const idCircuitoSinTurnoPrevio = [10];

  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------

  const dismiss = () => {
    hideModal()(modalDispatch);
  };
  const obtenerFechaActual = () => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  };
  const onClickBuscarPrestacion = (prestacion) => {
    setLoading(true);
    const { codigo, id } = nuevoTurnoState.nuevoTurno.familiar;
    dtoVerificaOs.idPacFamiliar = codigo === 0 ? -1 : id;
    dtoVerificaOs.id = prestacion.id;
    dtoVerificaOs.laboSeleccion = prestacion.descripcion;
    wsGetVerificarLaboGrupo(
      dtoVerificaOs.id,
      -1,
      nextStepVerificaOs,
    )(laboTurnosDispatch);
  };

  const nextStepVerificaOs = (isCorrect, data) => {
    if (isCorrect) {
      if (idCircuitoMensajesList.includes(data.codigo)) {
        setLoading(false);
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else if (idCircuitoParticular.includes(data.codigo)) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar como particular"}
            onClickCancelar={dismiss}
            onClick={onClickTomarComoParticular}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (
        idCircuitoOsAlternativa.includes(data.codigo) &&
        !data.continua
      ) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Tomar con OS alternativa"}
            onClick={onClickTomarConOsAlternativa}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (idCircuitoSinTurnoPrevio.includes(data.codigo)) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Ir a menú principal"}
            onClick={onClickSinTurnoPrevio}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        buscarTurnosDisponibles();
      }
    } else {
      setLoading(false);
      if (idCircuitoParticular.includes(parseInt(data?.detail))) {
        setLoading(false);
        showModal(
          <ModalVerificaOs
            data={data}
            strDescripcion={
              <div className="ModalVerificaOs-descripcion">
                <span className="ModalVerificaOs-bold">
                  ¿Desea tomar el turno como particular?
                </span>
                <span>
                  El estudio seleccionado no figura dentro de tu cobertura
                </span>
              </div>
            }
            btnAceptarStr={"Tomar como particular"}
            onClickCancelar={dismiss}
            onClick={onClickTomarComoParticular}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        showToaster(
          {
            texto: data ? data : "Error al verificar turno",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    }
  };

  const onClickTomarComoParticular = () => {
    dtoVerificaOs.particular = true;
    dtoVerificaOs.grupoMedico = {
      ...dtoVerificaOs.grupoMedico,
      Particular: true,
    };
    dismiss();
    setLoading(true);
    buscarTurnosDisponibles();
  };

  const buscarTurnosDisponibles = () => {
    let dtoPost = {
      fechaDesde: obtenerFechaActual(),
      idCentro: -1,
      idRecepcion: -1,
      idGrupoEstudio: dtoVerificaOs.id,
      idPacFamiliar: dtoVerificaOs.idPacFamiliar,
      laboSeleccion: dtoVerificaOs.laboSeleccion,
      particular: dtoVerificaOs.particular,
      osAlternativa: dtoVerificaOs.osAlternativa,
    };
    setNuevoTurno({ dtoBusqueda: dtoPost })(nuevoTurnoDispatch);
    wsGetLaboTurnos(
      dtoPost.fechaDesde,
      dtoPost.idCentro,
      dtoPost.idRecepcion,
      dtoPost.idGrupoEstudio,
      -1,
      (isCorrect, data) => nextStepTurnosDisponibles(isCorrect, data, dtoPost),
    )(laboTurnosDispatch);
  };
  const onClickTomarConOsAlternativa = () => {
    dtoVerificaOs.osAlternativa = true;
    setNuevoTurno({
      osAlternativa: true,
    })(nuevoTurnoDispatch);
    dismiss();
    setLoading(true);
    buscarTurnosDisponibles();
  };
  const onClickSinTurnoPrevio = () => {
    history.push("/home");
  };

  const nextStepTurnosDisponibles = (isCorrect, data, dtoPost) => {
    if (isCorrect) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: data.data,
        grupoMedico: null,
        particular: dtoVerificaOs.particular,
        idEstudio: dtoPost.idGrupoEstudio,
        descEstudio: dtoPost.laboSeleccion,
        descEspecialidad: null,
        fechaBusqueda: data.fechaBusqueda,
        dtoBusqueda: dtoPost,
        volverOrigen: "LABORATORIO",
        proceso: "labo",
      })(turnosDisponiblesDispatch);
      setLoading(false);
      history.push(`/turnosDisponibles`);
    }
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    if (laboGrupoState.laboGrupo.data) {
      setNuevoTurno({ familiar: authState.auth.data })(nuevoTurnoDispatch);
    } else {
      history.push("/autocheckin");
    }
  }, [laboGrupoState.laboGrupo.data]);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      {modalState.modal.show && <Modal />}
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <Layout>
        <SeleccionLaboratorioContainer>
          <BarraAzul
            title={"Laboratorio"}
            backBtn={true}
            pacienteSeleccionado={pacienteSeleccionado?.nombre}
          />
          <SeleccionLaboratorioHeader>
            <span>Seleccione el análisis a realizar</span>
          </SeleccionLaboratorioHeader>
          <SeleccionLaboratorioBody>
            <SeleccionLaboratorioGrid>
              {listaTurnos &&
                [...listaTurnos].reverse().map((item, index) => (
                  <SeleccionLaboratorioBotonAzul
                    selected={item.id === 5}
                    key={index}
                    onClick={() => onClickBuscarPrestacion(item)}
                  >
                    <span>{item.descripcion}</span>
                  </SeleccionLaboratorioBotonAzul>
                ))}
            </SeleccionLaboratorioGrid>
          </SeleccionLaboratorioBody>
        </SeleccionLaboratorioContainer>
      </Layout>
    </>
  );
};

export default SeleccionLaboratorio;
